import script from "./BillCellElementLite.vue?vue&type=script&setup=true&lang=ts"
export * from "./BillCellElementLite.vue?vue&type=script&setup=true&lang=ts"

import "./BillCellElementLite.vue?vue&type=style&index=0&id=5d62fd41&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5d62fd41"]])

export default __exports__